<template>
    <div class="flex w-full gap-5 h-full season-view justify-content-around overflow-hidden">
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center">
                <h2 class="page-header">{{ $t('message.season.header') }}</h2>
                <CustomButton :label="$t('message.season.addNewButton')" @click="addNewSeason"/>
            </div>
            <SeasonsTable ref="seasonTable" v-model="selectedSeason" @showForm="showForm"/>
        </div>
        <LibyanOrnament/>
        <div id="scrollToForm" class="section-details">
            <div class="flex justify-content-between align-items-center pr-1">
                <h2 class="page-header">{{ createMode ? $t('message.season.headerNew') : $t('message.season.headerEdit') }}</h2>
                <CustomIconButton icon="pi pi-times" onlyIcon @click="hideForm" class="close-form-button" />
            </div>
            <SeasonForm :selected-season="selectedSeason" @change-element="reloadTable"
                               @createMode="(val) => createMode = val" @hideForm="hideForm"/>
        </div>
    </div>
</template>

<script>
import CustomButton from "@/components/form/CustomButton.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import CustomIconButton from "@/components/form/CustomIconButton.vue";
import { ShowHideFormUtils } from "@/utils/ShowHideFormUtils";
import SeasonsTable from "@/views/dict/season/component/SeasonsTable.vue";
import SeasonForm from "@/views/dict/season/component/SeasonForm.vue";

export default {
    name: "SeasonListView",
    components: {
        SeasonForm,
        SeasonsTable,
        LibyanOrnament,

        CustomButton,
        CustomIconButton,
    },
    data() {
        return {
            selectedSeason: {},
            createMode: true,
        }
    },
    mounted() {
        this.selectedSeason = this.getClearSeason();
    },
    methods: {
        getClearSeason() {
            return {
                id: null,
                year: null,
                startDate: null,
                endDate: null,
                active: true
            };
        },
        reloadTable() {
            this.$refs.seasonTable.reloadTable();
            this.selectedSeason = this.getClearSeason();
        },
        addNewSeason() {
            ScrollToUtils.scrollToElement();
            this.$refs.seasonTable.addNewSeason();
            this.selectedSeason = this.getClearSeason();
            this.showForm();
        },
        showForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details");
        },
        hideForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details", true);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/theme/mytheme/variables";
.season-view {
    @media screen and (max-width: 1200px) {
        flex-direction: column;
        align-items: center;
        .section-table, .section-details {
            width: 90% !important;
        }
        .close-form-button {
            display: none;
        }
    }
}
.section-table, .section-details {
    transition: 1s ease-in-out;
}
.section-details {
    height: calc(100vh - 40px - $top-bar-height);;
    overflow-y: auto;
    width: 0;
}
</style>
